import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'modal-terminos',
  templateUrl: './modal-terminos.component.html',
  styleUrl: './modal-terminos.component.scss'
})
export class ModalTerminosComponent {
  constructor(public activateModal: NgbActiveModal) { }

  close() {
    this.activateModal.close();
  }
}
